import { jsx as _jsx } from "react/jsx-runtime";
import { debugInfoSectionPropsILeanProductTileAdapter } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/DebugInfoSection/debugInfoSectionPropsILeanProductTileAdapter";
import { productTileFavoritePropsILeanProductTileAdapter } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/Favorite/FavoriteProps";
import { searchProductImagePropsILeanProductTileAdapter } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductImage/search/SearchProductImageProps";
import { searchProductTileClickProviderPropsILeanProductTileAdapter } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductTileClickProvider/search/SearchProductTileClickProviderProps";
import { productTileTrackingWrapperPropsILeanProductTileAdapter } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductTileTrackingWrapper/ProductTileTrackingWrapperProps";
import { productTileQuickAddPropsILeanProductTileAdapter } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/QuickAdd/QuickAddProps";
import { productTileTopBadgesPropsILeanProductTileAdapter } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/TopBadges/TopBadgesProps";
import { LoggedInSearchProductTile } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/LoggedInSearchProductTile";
import { LoggedOutSearchProductTile } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/LoggedOutSearchProductTile";
import { useIsLoggedInRetailerOrBrandPreview } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import { PrehydrationClickTrackingWrapper } from "@faire/retailer-visitor-shared/lib/nextjs-rsc/PrehydrationClickTrackingWrapper";
import { showProductPromotions } from "@faire/retailer-visitor-shared/lib/showProductPromotions";
import { PRICE_TEXT_SURFACE } from "@faire/retailer-visitor-shared/views/product/ProductDetails/Price/PriceProps";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { useSearchPageIsRsc } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/useSearchPageIsRsc";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { useSearchPageSpellCorrectedQuery } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/useSearchPageSpellCorrectedQuery";
import { useSearchPageProductSearchString } from "@faire/retailer-visitor-shared/views/search-v2/SearchPageQueryParams/useSearchPageProductSearchString";
import { useSearchPageActionName } from "@faire/retailer-visitor-shared/views/search-v2/util/useSearchPageActionName";
import { useTraceComponentRender } from "@faire/web--source/common/tracing/useTraceComponentRender";
import React from "react";
export var SearchProductTile = function(props) {
    var _props_productTile_product, _brand_insider_label;
    useTraceComponentRender("SearchProductTile", {
        productToken: (_props_productTile_product = props.productTile.product) === null || _props_productTile_product === void 0 ? void 0 : _props_productTile_product.token
    });
    var isLoggedIn = useIsLoggedInRetailerOrBrandPreview();
    var productTile = props.productTile, brand = props.brand;
    var productSearchString = useSearchPageProductSearchString();
    var spellCorrectedQuery = useSearchPageSpellCorrectedQuery();
    var insiderBadgeProps = {
        insiderBenefits: brand === null || brand === void 0 ? void 0 : brand.insider_benefits,
        insiderLabelText: brand === null || brand === void 0 ? void 0 : (_brand_insider_label = brand.insider_label) === null || _brand_insider_label === void 0 ? void 0 : _brand_insider_label.text
    };
    var searchPriceTextProps = {
        min_option_wholesale_price: productTile.min_option_wholesale_price,
        min_option_wholesale_promo_price: productTile.min_option_wholesale_promo_price,
        min_option_retail_price: productTile.min_option_retail_price,
        showProductPromotions: showProductPromotions(productTile.min_option_wholesale_promo_price),
        small: true,
        isLoggedInOrBrandPreview: isLoggedIn,
        isTilePricing: true,
        priceTextSurface: PRICE_TEXT_SURFACE.PRODUCT_TILE
    };
    var searchProductTileProps = {
        productTileImageProps: searchProductImagePropsILeanProductTileAdapter(productTile, productSearchString, spellCorrectedQuery),
        productTileTrackingWrapperProps: productTileTrackingWrapperPropsILeanProductTileAdapter(productTile),
        productTileDebugInfoProps: debugInfoSectionPropsILeanProductTileAdapter(productTile),
        productTileTopBadgesProps: productTileTopBadgesPropsILeanProductTileAdapter(productTile),
        productTileFavoriteProps: productTileFavoritePropsILeanProductTileAdapter(productTile),
        productTileQuickAddProps: productTileQuickAddPropsILeanProductTileAdapter(productTile),
        productTileClickProviderProps: searchProductTileClickProviderPropsILeanProductTileAdapter(productTile),
        priceTextProps: searchPriceTextProps,
        productTile: productTile,
        brand: brand,
        insiderBadgeProps: insiderBadgeProps,
        productSearchString: productSearchString
    };
    if (isLoggedIn) {
        return /*#__PURE__*/ _jsx(LoggedInSearchProductTile, {
            data: searchProductTileProps
        });
    } else {
        return /*#__PURE__*/ _jsx(LoggedOutSearchProductTile, {
            data: searchProductTileProps
        });
    }
};
export var SearchProductTilePrehydrationClickTrackingWrapper = function(param) {
    var productToken = param.productToken, children = param.children;
    var actionName = useSearchPageActionName();
    var isRsc = useSearchPageIsRsc();
    return /*#__PURE__*/ _jsx(PrehydrationClickTrackingWrapper, {
        name: actionName,
        isRsc: isRsc,
        location: "product-tile-".concat(productToken),
        children: children
    });
};
